<template>
    <div>
        <div>
            <form v-on:submit="saveForm()">
                <div class="row">
                    <div class="col-12 form-group">
                        <label class="control-label">Проверочный код
                            <input type="text" v-model="vk_confirm_token" class="form-control"
                                   @input="isChanged = true">
                        </label>
                    </div>
                </div>
                <div v-if="error" class="error">
                    Ошбика {{error}}
                </div>
                <div class="row">
                    <div class="col-12 form-group">
                        <button class="btn btn-success" v-bind:disabled="!isChanged">Сохранить</button>
                        <button class="btn btn-default" v-bind:disabled="!isChanged" @click="cancel()">Отменить</button>
                    </div>
                </div>
            </form>
        </div>
        <h3>Адрес для отправки заявок:</h3>
        <input class="form-control" readonly v-bind:value="vkAddress">
    </div>
</template>

<script>
    import axios from "axios";
    import {DOMAINS_REQUEST} from "../../store/actions/domains";

    export default {
        name: "DomainVkIntegration",
        props: {
            domain: Object
        },
        data: function () {
            return {
                vk_confirm_token: null,
                error: null,
                isChanged: false
            }
        },
        computed: {
            vkAddress: function () {
                return this.$store.state.app.server + '/api/' + this.domain.id + '/vk/lead';
            }
        },
        mounted() {
            this.loadDomainInfo();
        },
        watch: {
            domain() {
                this.loadDomainInfo();
            }
        },
        methods: {
            loadDomainInfo: function () {
                if (this.domain) {
                    this.vk_confirm_token = this.domain.vk_confirm_token;
                } else {
                    this.vk_confirm_token = null;
                }
                this.isChanged = false;
            },
            saveForm: function () {
                this.error = null;
                event.preventDefault();
                axios.put('/api/domain/update/' + this.domain.id, {vk_confirm_token: this.vk_confirm_token})
                    .then(() => {
                        // Обновляем список доменов
                        this.$store.dispatch(DOMAINS_REQUEST);
                    })
                    .catch(error => {
                        this.error = error;
                        console.log(error);
                    })
            },
            cancel: function () {
                event.preventDefault();
                this.loadDomainInfo();
            }
        }
    }
</script>

<style scoped>

</style>